import { settingsManager } from '../../../shared/settings';
import { MSGraphScopes } from './constants';
export const getMSGraphScopeAndEndPoint = (scope: MSGraphScopes) => {
  const MSGraphEndPoint = settingsManager.getRequired('msGraphResourceName');
  // being more defensive here just in case the msGraphResourceName format is changed in the future
  const finalScope = MSGraphEndPoint.endsWith('/') ? `${MSGraphEndPoint}${scope}` : `${MSGraphEndPoint}/${scope}`;
  return {
    scope: finalScope,
    MSGraphEndPoint,
  };
};